import { FertilizerApplicationMethod } from 'services/fertilizerEvents/types';
import { AppState } from 'services/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { FERTILIZER_EVENT_APPLICATION_METHOD_OPTIONS } from '../../../../../FertilizerEventApplicationPage/components/FertilizerEventApplicationMethodDropdown/constants';
import { OwnProps } from './index';

const selectApplicationMethod = (
    _state: AppState,
    props: OwnProps
): FertilizerApplicationMethod => props.applicationMethod;

const selectApplicationMethodText = createDeepEqualSelector(
    selectApplicationMethod,
    (applicationMethod) =>
        FERTILIZER_EVENT_APPLICATION_METHOD_OPTIONS.find(
            (option) => option.value === applicationMethod
        )?.text
);

export { selectApplicationMethodText };
